module.exports = __webpack_public_path__ + "assets/img/74.d76f7ca1.png";